<template>
  <div>
    <b-overlay rounded="sm">
      <ValidationObserver ref="searchForm" slim>
        <b-form @submit.prevent="$event => submit()" class="filters-form">
          <b-row>
            <b-col sm="12">
              <h4 class="view-name" v-translate>Tours</h4>
            </b-col>
            <b-col sm="4">
              <h5 class="d-flex justify-content-between border-bottom pb-1 mb-n1 mb-0" v-b-toggle.collapse1>
                <span class="font-weight-bold my-0 py-0 tour-labels" v-translate>Zones</span>
                <span>
                  <b-badge class="mr-2 custom-badge" variant="info"> {{ selectedParams.areas.length }} / {{ areasOptions.length }} </b-badge>
                  <span><b-icon icon="caret-down-fill"/></span>
                </span>
              </h5>
              <b-collapse id="collapse1">
                <b-card class="">
                <b-form-checkbox-group
                v-model="selectedParams.areas"
                :options="areasOptions"
                stacked
              ></b-form-checkbox-group>
              </b-card>
              </b-collapse>
            </b-col>
            <b-col sm="4">
              <h5 class="d-flex justify-content-between border-bottom pb-1 mb-n1 mb-0" v-b-toggle="'categories'">
                <span class="font-weight-bold my-0 py-0 tour-labels" v-translate>Categories</span>
                <span>
                  <b-badge class="mr-2 custom-badge" variant="info"> {{ selectedParams.categories.length }} / {{  categoriesOptions.length }} </b-badge>
                  <span><b-icon icon="caret-down-fill"/></span>
                </span>
              </h5>
              <b-collapse id="categories">
                <b-card class="">
                  <b-form-checkbox-group
                    v-model="selectedParams.categories"
                    :options="categoriesOptions"
                    stacked
                  ></b-form-checkbox-group>
                  <template v-if="selectedParams.categories && selectedParams.categories.length > 1">
                    <hr>
                    <div class="d-flex justify-content-end">
                      <b-form-radio-group v-model="selectedParams.categories_all">
                        <b-form-radio :value="false" v-translate>any</b-form-radio>
                        <b-form-radio :value="true" v-translate>all selected</b-form-radio>
                      </b-form-radio-group>
                    </div>
                  </template>
                </b-card>
              </b-collapse>
            </b-col>
            <b-col sm="4">
              <h5 class="d-flex justify-content-between align-items-center border-bottom pb-1 mb-n1 mb-0" v-b-toggle="'departures'">
                <span class="font-weight-bold my-0 py-0 tour-labels" v-translate>Departures</span>
                <span>
                  <b-badge class="mr-2 custom-badge" variant="info"> {{ selectedParams.departures.length }} / {{ departuresOptions.length }} </b-badge>
                  <span><b-icon icon="caret-down-fill"/></span>
                </span>
              </h5>
              <b-collapse id="departures">
                <b-card>
                  <b-form-checkbox-group
                  v-model="selectedParams.departures"
                  :options="departuresOptions"
                  stacked
                ></b-form-checkbox-group>
                </b-card>
              </b-collapse>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col sm="12">
              <h5 class="d-flex justify-content-between border-bottom pb-1 mb-1 mb-0" v-b-toggle="'destinations'">
                <span class="font-weight-bold my-0 py-0 tour-labels">Destinations</span>
                <span>
                  <b-badge class="mr-2 custom-badge" variant="info"> {{ selectedParams.destinations.length }} / {{ destinationsList.length }} </b-badge>
                  <span><b-icon icon="caret-down-fill"/></span>
                </span>
              </h5>
            </b-col>
            <b-collapse id="destinations">
            <b-row class="px-3">
              <b-col sm="3" v-for="country in countriesOptions" :key="'country' + country.value">
              <div class="accordion" role="tablist">
                <div class="mb-1">
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                        class="float-left"
                        v-model="allSelectedModel[country.value]"
                        :indeterminate="indeterminate[country.value]"
                        @change="toggleAll(country.value)"
                        />
                    <b-button block v-b-toggle="'country' + country.value" class="text-left" size="sm" variant="outline-info">
                      <span>{{ country.text }}</span>
                      <b-badge class="float-right mt-1" variant="info">{{ countriesSelectedCount[country.value] }} / {{ destinationsOptions[country.value].length }} </b-badge>
                    </b-button>
                  </div>
                  <b-collapse :id="'country' + country.value" role="tabPanel">
                    <b-card>
                      <b-form-checkbox-group
                        v-model="selectedParams.destinations"
                        :options="destinationsOptions[country.value]"

                        stacked
                      ></b-form-checkbox-group>
                    </b-card>
                  </b-collapse>
                </div>
              </div>
            </b-col>
            </b-row>
            </b-collapse>
          </b-row>
          <b-row>
            <b-col sm="2">
              <b-form-group
                :label="$gettext('Duration (from)')"
                label-class="mb-0"
                label-for="min_duration"
                class="mb-0"
              >
                <b-input
                  type="number"
                  name="min_duration"
                  id="min_duration"
                  v-model="selectedParams.min_duration"
                  :placeholder="$gettext('From')"
                  min="0"
                  max="100"
                  size="sm" />
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group
                :label="$gettext('Duration (to)')"
                label-class="mb-0"
                label-for="max_duration"
                class="mb-0"
              >
                <b-input
                  type="number"
                  name="max_duration"
                  id="max_duration"
                  v-model="selectedParams.max_duration"
                  :placeholder="$gettext('To')"
                  min="0"
                  max="100"
                  size="sm" />
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group
                :label="$gettext('Accommodation (from)')"
                label-class="mb-0"
                label-for="min_accommodation"
                class="mb-0"
              >
                <b-input
                  type="number"
                  name="min_accommodation"
                  id="min_accommodation"
                  v-model="selectedParams.min_accommodation"
                  :placeholder="$gettext('From')"
                  min="0"
                  max="100"
                  size="sm" />
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group
                :label="$gettext('Accommodation (to)')"
                label-class="mb-0"
                label-for="max_accommodation"
                class="mb-0"
              >
                <b-input
                  type="number"
                  name="max_accommodation"
                  id="max_accommodation"
                  v-model="selectedParams.max_accommodation"
                  :placeholder="$gettext('To')"
                  min="0"
                  max="100"
                  size="sm" />
              </b-form-group>
            </b-col>
            <b-col sm="2">
              <label class="mb-0"><translate>Check in</translate></label>
              <DatePicker
                  v-model="selectedCheckIn"
                  id="checkIn"
                  size="sm"
                  placeholder="dd/mm/yyyy"
                  lang="en"
                  today-label="today"
                  selected-date-label="selected date"
                  aria-describedby="checkin-live-feedback"
                ></DatePicker>
            </b-col>
            <b-col sm="2">
              <label class="mb-0"><translate>Check out</translate></label>
              <DatePicker
                  v-model="selectedCheckOut"
                  id="checkOut"
                  size="sm"
                  lang="en"
                  today-label="today"
                  selected-date-label="selected date"
                  class="hp-btn"
                  placeholder="dd/mm/yyyy"
                  aria-describedby="checkout-live-feedback"
                ></DatePicker>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2">
              <b-form-group
                :label="$gettext('Currency')"
                label-class="mb-0"
                label-for="currency"
                class="mb-0"
              >
                <b-form-select
                  v-model="selectedParams.currency"
                  :options="['EUR', 'RON']"
                  size="sm"
                  id="currency"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                :label="$gettext('Transport')"
                label-class="mb-0"
                label-for="transport"
                class="mb-0"
              >
                <b-form-select
                  v-model="selectedParams.transport"
                  :options="[
                    { value: null, text: $gettext('Any') },
                    { value: 'flight', text: $gettext('Flight') },
                    { value: 'bus', text: $gettext('Bus') }
                  ]"
                  size="sm"
                  id="transport"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                :label="$gettext('Tour name')"
                label-class="mb-0"
                label-for="key-word"
              >
                <b-input
                  type="text"
                  name="keyword"
                  v-model="selectedParams.keyword"
                  id="key-word"
                  size="sm" />
              </b-form-group>
            </b-col>
            <!--room-->
            <b-col md="2"
              v-for="(room, i) in selectedParams.rooms"
              :key="'room' + room.id">
              <b-form-group
                label="Room"
                label-class="mb-0"
                class="mb-0"
              >
                <room
                  v-model="selectedParams.rooms[i]"
                  :id="i"
                  :showDelete="i && (selectedParams.rooms.length > 1)"
                  :showAdd = "!i && (selectedParams.rooms.length < 3)"
                  @add = "onRoomAdd"
                  @delete = "onRoomDelete(i)"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-0 mb-2">
            <b-col sm="12"><hr></b-col>
            <b-col sm="12" class="d-flex align-items-center justify-content-end">
              <b-button variant="success" size="sm" type="submit"><b-icon icon="search" /><span class="ml-2" v-translate>Search</span></b-button>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>
    </b-overlay>
  </div>
</template>

<script>
import moment from 'moment'
import { getAreas, getCategories, getDeparturePoints, getDestinations, getSearchParams } from 'b2b-common/services/api/tour'
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'
import DatePicker from 'b2b-common/components/datepicker'
import room from '@/app/private/shared/components/search_form_room'
import formMixin from '@/app/private/shared/mixins/search_forms'

const random = () => {
  return Math.floor((Math.random() * 100000 + 1))
}

export default {
  name: 'SearchForm',
  mixins: [formMixin, validation, toast],
  components: { DatePicker, room },
  data () {
    return {
      selectedCurrency: 'EUR',
      selectedParams: {
        areas: [],
        categories: [],
        categories_all: true,
        departures: [],
        destinations: [],
        min_duration: null,
        max_duration: null,
        min_accommodation: null,
        max_accommodation: null,
        date_from: null,
        date_to: null,
        keyword: '',
        currency: 'EUR',
        rooms: [{
          id: random(),
          adults: 2,
          ages: []
        }]
      },
      departuresList: [],
      destinationsList: [],
      areasList: [],
      categoriesList: [],
      allSelectedModel: {}
    }
  },
  computed: {
    areasOptions () {
      return this.areasList.map(el => ({ value: el.id, text: el.name }))
    },
    categoriesOptions () {
      return this.categoriesList.filter(el => el.active !== 'f').map(el => ({ value: el.id, text: el.name }))
    },
    departuresOptions () {
      return this.departuresList.map(el => ({ value: el.id, text: el.name }))
    },
    countriesOptions () {
      const countries = []
      this.destinationsList.forEach(el => {
        if (!countries.find(country => country.value === el.country_id)) {
          countries.push({ value: el.country_id, text: el.country_name })
        }
      })
      countries.sort((a, b) => a.text.localeCompare(b.text))
      return countries
    },
    countriesSelectedCount () {
      const selectedCount = {}
      this.destinationsList.forEach(el => {
        if (!selectedCount[el.country_id]) {
          selectedCount[el.country_id] = 0
        }
        if (this.selectedParams.destinations && this.selectedParams.destinations.includes(el.city_id)) {
          selectedCount[el.country_id]++
        }
      })
      return selectedCount
    },
    destinationsOptions () {
      const destinations = {}
      this.destinationsList.forEach(el => {
        if (!destinations[el.country_id]) {
          destinations[el.country_id] = []
        }
        destinations[el.country_id].push({ value: el.city_id, text: el.city_name })
      })
      return destinations
    },
    selectedCheckIn: {
      get () {
        const mVal = moment(this.selectedParams.date_from, 'YYYY-MM-DD')
        if (mVal.isValid()) return mVal.toDate()
        return null
      },
      set (val) {
        this.selectedParams.date_from = val ? moment(val).format('YYYY-MM-DD') : null
      }
    },
    selectedCheckOut: {
      get () {
        const mVal = moment(this.selectedParams.date_to, 'YYYY-MM-DD')
        if (mVal.isValid()) return mVal.toDate()
        return null
      },
      set (val) {
        this.selectedParams.date_to = val ? moment(val).format('YYYY-MM-DD') : null
      }
    },
    indeterminate () {
      const indeterminate = {}
      for (const countryId in this.countriesSelectedCount) {
        indeterminate[countryId] = this.countriesSelectedCount[countryId] > 0 && this.countriesSelectedCount[countryId] < this.destinationsOptions[countryId].length
      }
      return indeterminate
    }
    // allSelected () {
    //   if (this.allSelectedModel === null)
    //   for (const countryId in this.countriesSelectedCount) {
    //     allSelected[countryId] = this.countriesSelectedCount[countryId] === this.destinationsOptions[countryId].length
    //   }
    //   return allSelected
    // }
  },
  methods: {
    async getDeparturesList () {
      this.resetList('departures')
      this.addRequest('departures')
      try {
        this.departuresList = await getDeparturePoints()
      } finally {
        this.removeRequest('departures')
      }
      return this.departuresList
    },
    async getDestinationsList () {
      this.resetList('destinations')
      this.addRequest('destinations')
      try {
        this.destinationsList = await getDestinations()
      } finally { this.removeRequest('destinations') }
      return this.destinationsList
    },
    async getAreasList () {
      this.resetList('areas')
      this.addRequest('areas')
      try {
        const res = await getAreas()
        this.areasList = []
        for (const key in res) {
          this.areasList.push(res[key])
        }
      } finally { this.removeRequest('areas') }
      return this.areasList
    },
    async getCategoriesList () {
      this.resetList('categories')
      this.addRequest('categories')
      try {
        this.categoriesList = []
        const res = await getCategories()
        for (const key in res) {
          this.categoriesList.push(res[key])
        }
      } finally { this.removeRequest('areas') }
      return this.categoriesList
    },
    async getSearchParams () {
      this.resetList('searchParams')
      this.addRequest('searchParams')
      try {
        const params = await getSearchParams()
        for (const key in params) {
          if (key === 'rooms') continue
          this.$set(this.selectedParams, key, params[key])
        }
        // remove all rooms from rooms array
        this.selectedParams.rooms.splice(0, this.selectedParams.rooms.length)
        if (params.rooms && params.rooms.length) {
          for (let i = 0; i < params.rooms.length; i++) {
            this.selectedParams.rooms.push({ ...params.rooms[i], id: random() })
          }
        } else {
          this.selectedParams.rooms.push({ id: random(), adults: 2, ages: [] })
        }
      } finally { this.removeRequest('searchParams') }
    },
    async submit () {
      const success = await this.$refs.searchForm.validate()
      if (!success) {
        this.addToast({
          title: 'Formular invalid',
          message: 'Va rugam completati toate campurile obligatorii!',
          variant: 'danger'
        })
      } else {
        this.$emit('search', this.selectedParams)
      }
    },
    toggleAll (countryId) {
      const selected = this.selectedParams.destinations || []
      const countryDestinations = this.destinationsOptions[countryId].map(el => el.value)
      if (!this.allSelectedModel[countryId]) {
        this.selectedParams.destinations = selected.filter(el => !countryDestinations.includes(el))
      } else {
        this.selectedParams.destinations = [...selected, ...countryDestinations.filter(el => !selected.includes(el))]
      }
    }
  },
  async mounted () {
    await Promise.all([
      this.getDeparturesList(),
      this.getDestinationsList(),
      this.getAreasList(),
      this.getCategoriesList(),
      this.getSearchParams()
    ])
    this.allSelectedModel = {}
    for (const countryId in this.countriesSelectedCount) {
      this.allSelectedModel[countryId] = this.countriesSelectedCount[countryId] === this.destinationsOptions[countryId].length
    }
  }
}
</script>

<style>
legend.mb-0{
  color: #3c7eb7;
  font-size: 12px;
  font-weight: bold;
  line-height: 2;
  margin-bottom: 0px;
  padding: 0px;
}
.badge.custom-badge {
  font-size:60%;
}
.tour-labels {
  font-size: 14px;
  font-weight: bold;
}
</style>
